import React from "react";
import { useTranslation } from "react-i18next";
const NoStoreFrontData = () => {
    const {t} = useTranslation();
    return (
        <div className="flex justify-center">
            <div className='text-center'>
                <img src='/svg/landing.svg' alt='no_data' className='w-150' />
                <div>
                    <h2 className="mb-8">{t('loading_products_message')}</h2>
                </div>
            </div>
        </div>
    );
}
export default NoStoreFrontData;